export const isVisible = state => state.isVisible;
